<template>
  <div
    :class="['card-item', { 'card-item--compact': subtitle }]"
    :disabled="inactive || undefined"
    @click="handleClick"
  >
    <span v-if="logoSrc" class="card-item__logo">
      <img :src="logoSrc" :alt="logoAlt" />
    </span>
    <span class="card-item__content">
      <span class="bold">{{ title }}</span>
      <span v-if="subtitle" class="card-item__subtitle">{{ subtitle }}</span>
    </span>
    <span v-if="rightText" :class="['card-item__right', { bold: rightTextBold }]">{{ rightText }}</span>
    <img class="card-item__chevron" src="@/assets/icons/chevron_right.svg" alt="Chevron Right" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "CardItem",
  props: {
    logoSrc: { type: String, default: "" },
    logoAlt: { type: String, default: "" },
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    rightText: { type: String, default: "" },
    rightTextBold: { type: Boolean, default: false },
    // Purely cosmetic: dims the card to signal an inactive state. It does NOT
    // block the click — the parent owns the decision of what happens on click.
    inactive: { type: Boolean, default: false },
  },
  emits: ["click"],
  setup(_props, { emit }) {
    const handleClick = () => {
      emit("click");
    };
    return { handleClick };
  },
});
</script>

<style scoped>
.card-item {
  display: flex;
  padding: 24px 16px;
  margin-top: 16px;
  align-items: center;
  border-radius: 16px;
  background: white;
  box-shadow: 0 4px 8px 3px rgba(169, 169, 169, 0.15);
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.card-item:hover:not([disabled]) {
  background-color: #f5f5f5;
}

.card-item__logo {
  text-align: left;
  align-items: center;
  display: flex;
  min-width: 40px;
}

.card-item__logo img {
  max-width: 32px;
  max-height: 32px;
  object-fit: contain;
}

span.bold {
  line-height: 26px;
}

.card-item__content {
  margin-inline: 12px;
  flex: 1 0 0;
  display: flex;
  flex-direction: column;
  text-align: left;
  color: black;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px;
}

.card-item__subtitle {
  color: var(--Typography-Text-2);
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
}

.card-item__right {
  margin-left: auto;
}

.card-item__chevron {
  margin-left: 8px;
}

.card-item--compact {
  padding: 16px;
}

.card-item[disabled] {
  cursor: default;
  opacity: 0.5;
}

.card-item[disabled] .card-item__logo img {
  filter: grayscale(100%);
}
</style>
